var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.580473 18.9333C0.300749 15.8563 2.72348 13.2034 5.81313 13.2034H34.2382C37.3279 13.2034 39.7506 15.8563 39.4709 18.9333L37.2736 43.1028C37.0276 45.8091 34.7585 47.8813 32.041 47.8813H8.01036C5.29285 47.8813 3.02373 45.8091 2.7777 43.1028L0.580473 18.9333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55985 16.3558C9.55985 16.3558 8.25169 2.69482 20.0251 2.69482C31.7985 2.69482 30.4903 16.3558 30.4903 16.3558",
    stroke: "black",
    strokeWidth: 4.20339,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6182 23.7118H29.4826",
    stroke: "white",
    strokeWidth: 2.10169,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6182 31.0677H29.4826",
    stroke: "white",
    strokeWidth: 2.10169,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6182 38.4237H21.2375",
    stroke: "white",
    strokeWidth: 2.10169,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingOrder);
export default __webpack_public_path__ + "static/media/shopping-order.c1f57b75eb6686627262de31f5ca8fdd.svg";
export { ForwardRef as ReactComponent };